import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
export interface IMySelectOption {
  id: number;
  value: string;
  label: string;
}
declare var $: any;

@Component({
  selector: 'app-additional-account-modal',
  templateUrl: './additional-account-modal.component.html',
  styleUrls: ['./additional-account-modal.component.scss'],
})
export class AdditionalAccountModalComponent implements OnInit {
  @Input('data') data: string = 'additional';
  @Input('activeChatCustomers') activeChatCustomers: any = [];
  public selectedChatCust: string = "";
  disable: boolean = true;
  hideSubHeading: boolean = false;
  @Output() buttonClicked = new EventEmitter<any>();
  public selectedValue?: IMySelectOption;
  public secondSelectedValue?: IMySelectOption;
  public options: IMySelectOption[] = [
    {
      id: 1,
      value: 'value1',
      label: 'Authorized user required info',
    },
    {
      id: 2,
      value: 'value2',
      label: 'Agent required info',
    },
  ];

  public suboptions: IMySelectOption[] = [
    {
      id: 3,
      value: 'HR-Manager',
      label: 'HR/ Manager',
    },
    {
      id: 4,
      value: 'Clientpartner',
      label: 'Client Partner',
    },
    {
      id: 5,
      value: 'Unionrep',
      label: 'Union Rep',
    },
  ];
  constructor() { }

  ngOnInit(): void { }

  /*click event response send back to parent compnent  */
  typeHeadChange(event) {
    this.disable = true;
    this.buttonClicked.emit({
      btnName: event.target.text,
      primaryValue: this.selectedValue,
      secondaryValue: this.secondSelectedValue,
      customer: this.selectedChatCust
    });
  }

  /*selection of radio button enable/disable the continue button function  */
  toggleMethod() {
    if (this.selectedValue?.id === 1) {
      this.hideSubHeading = true;
      this.disable = true;
    } else {
      this.hideSubHeading = false;
      this.disable = false;
      this.secondSelectedValue = {
        id: NaN,
        value: '',
        label: '',
      };
    }
  }
  /* sub radio button selection base set enable and disable continue button */
  subtoggleMethod() {
    if (this.secondSelectedValue?.id) {
      this.disable = false;
    }
  }
  /*multi customer Selection value update in global valribale  */
  changeCustomer() {
    if (this.selectedChatCust) { this.disable = false; }
  }
}
